module.exports = __webpack_public_path__ + "static/media/盯盘提醒@2x.c0ec7f9b.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_171/images/盯盘提醒@2x.png
// module id = 1536
// module chunks = 0